import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Checkbox, IconButton, Slider } from '@mui/material';
import React from 'react';
import classes from './style.module.scss';

const ThresholdCard = (props) => {
  const disableUp = (props.index == 0);
  const disableDown = (props.index == 6);

  // Child items don't have up/down buttons
  const isChild = props.isChild || false;
  const parentEnabled = props.parentEnabled !== false;
  const isEnabled = props.value.enable == 1;

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    props.changeValue(props.index, newValue);
  };

  const handleChangeEnable = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.changeEnable(props.index, event.target.checked ? 1 : 0);
  };

  const handleDown = () => {
    props.handleDown(props.index);
  };

  const handleUp = () => {
    props.handleUp(props.index);
  };

  return (
    <div className={`${classes.divParent} ${isChild ? classes.childItem : ''}`}>
      {!isChild ? (
        <>
          <IconButton disabled={disableUp} onClick={handleUp}>
            <ArrowDropUpIcon />
          </IconButton>
          <IconButton disabled={disableDown} onClick={handleDown}>
            <ArrowDropDownIcon />
          </IconButton>
        </>
      ) : (
        <>
          <div style={{ width: '40px' }} />
          <div style={{ width: '40px' }} />
        </>
      )}
      <h3 className={`${classes.textCategory} ${isChild ? classes.childCategory : ''}`}>
        {isChild && <span style={{ marginRight: '8px', opacity: 0.6 }}> </span>}
        {props.value.category}
      </h3>
      <Slider
        aria-label="Temperature"
        value={props.value.value}
        valueLabelDisplay="auto"
        step={1}
        marks
        min={1}
        max={5}
        disabled={props.value.enable == 0 || !parentEnabled}
        onChange={handleSliderChange}
      />
      <div className={classes.divEnable}>
        <Checkbox
          checked={isEnabled && parentEnabled}
          onChange={handleChangeEnable}
          disabled={!parentEnabled}
          title={!parentEnabled ? 'Enable parent category first' : ''}
        />
      </div>
    </div>
  );
};

export default ThresholdCard;
